// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__1-cvh","label":"Completed_label__3W-oZ"};